import React from "react";
import ClientInform from "../../views/clientView/clientInform";

export default function ClientInformPage() {
    return <ClientInform />
}